import MenuLateral from "./components/MenuLateral";
import NavMenu from "./components/Nav";
const Gerenciamento = () => {
    
    return <>
        <NavMenu />
        <div className="container">
            <div>
                <MenuLateral />
            </div>
        </div>
    </>
}

export default Gerenciamento;